var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { FlightSelect } from '@flybits/design-system';
var PluginDropdown = function (renderProps) {
    var uiBlock = renderProps.uiBlock, updateUiBlock = renderProps.updateUiBlock, contextPlugins = renderProps.contextPlugins;
    var DEFAULT_CLASS = 'plugin-dropdown';
    var PLUGIN_FIELD_WIDTH = '350px';
    var PLACEHOLDER = 'Select an attribute';
    var getUpdatedPlugins = function (selectedBlock, contextPlugins) {
        var selectedPluginValue = null;
        if ((contextPlugins === null || contextPlugins === void 0 ? void 0 : contextPlugins.length) && selectedBlock) {
            var _a = selectedBlock.contextComparisonPlugin, plugin_1 = _a.plugin, attribute_1 = _a.attribute;
            contextPlugins.forEach(function (contextPlugin) {
                var pluginAttributes = contextPlugin.values;
                var keys = Object.keys(pluginAttributes);
                if (pluginAttributes && (keys === null || keys === void 0 ? void 0 : keys.length)) {
                    keys.forEach(function (key) {
                        var pluginAttribute = pluginAttributes[key];
                        var splitAttributeName = attribute_1 === null || attribute_1 === void 0 ? void 0 : attribute_1.split('.');
                        var attributeName = (splitAttributeName === null || splitAttributeName === void 0 ? void 0 : splitAttributeName[0]) === 'query' ? splitAttributeName[1] : attribute_1;
                        if ((plugin_1 === contextPlugin.id || plugin_1 === contextPlugin.uid) && attributeName === key) {
                            selectedPluginValue = {
                                name: "".concat(contextPlugin.name.toLowerCase(), " / ").concat(pluginAttribute.name.toLowerCase()),
                                key: pluginAttribute.uid,
                                attribute: key,
                                plugin: contextPlugin.uid,
                            };
                        }
                    });
                }
            });
        }
        return selectedPluginValue;
    };
    var getPluginsList = function (selectedBlock, contextPlugins) {
        var attributes = [];
        if ((contextPlugins === null || contextPlugins === void 0 ? void 0 : contextPlugins.length) && selectedBlock) {
            var type_1 = selectedBlock.contextComparisonPlugin.type;
            contextPlugins.forEach(function (contextPlugin) {
                var pluginAttributes = contextPlugin.values;
                var keys = Object.keys(pluginAttributes);
                if (pluginAttributes && (keys === null || keys === void 0 ? void 0 : keys.length)) {
                    keys.forEach(function (key) {
                        var pluginAttribute = pluginAttributes[key];
                        if (pluginAttribute.uid !== selectedBlock.ctxVariable &&
                            (pluginAttribute.valueType === selectedBlock.contextParameterType || pluginAttribute.valueType === type_1)) {
                            attributes.push({
                                name: "".concat(contextPlugin.name.toLowerCase(), " / ").concat(pluginAttribute.name.toLowerCase()),
                                key: pluginAttribute.uid,
                                attribute: pluginAttribute.uid.includes('query')
                                    ? "query.".concat(key, ".").concat(Array(pluginAttribute.parameters.length).fill('*').join('.'))
                                    : key,
                                plugin: contextPlugin.uid,
                            });
                        }
                    });
                }
            });
        }
        return attributes;
    };
    var _a = __read(useState(getUpdatedPlugins(uiBlock, contextPlugins)), 2), selectedPlugin = _a[0], setSelectedPlugin = _a[1];
    var pluginDropdownOptions = getPluginsList(uiBlock, contextPlugins);
    var handleDropdownChange = function (option) {
        setSelectedPlugin(option);
        updateUiBlock(__assign(__assign({}, uiBlock), { contextComparisonPlugin: __assign(__assign({}, uiBlock.contextComparisonPlugin), { plugin: option.plugin, attribute: option.attribute }) }));
    };
    return (React.createElement(FlightSelect, { className: DEFAULT_CLASS, options: pluginDropdownOptions, handleOptionClick: function (option) { return handleDropdownChange(option); }, label: PLACEHOLDER, selected: selectedPlugin, width: PLUGIN_FIELD_WIDTH }));
};
export default PluginDropdown;
//# sourceMappingURL=PluginDropdown.js.map